import PropTypes from 'prop-types';

import MillesimaPrice from '@/components/common/price/MillesimaPrice';

import styles from './PriceLine.module.scss';

const PriceLine = ({ name, price, quantity = undefined, addTitle = false, className = '', ...props }) => {
  const containerClassName = [
    styles.container,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClassName} data-test-id="price-line" data-rbf="price-line" {...props}>
      <div className={styles.name} title={addTitle ? name : ''} data-test-id="name">{name}</div>
      {quantity && (
        <div data-test-id="qty">x {quantity}</div>
      )}
      <MillesimaPrice value={price} className={{ container: styles.price }} />
    </div>
  );
};

PriceLine.propTypes = {
  name: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  price: PropTypes.number.isRequired,
  addTitle: PropTypes.bool,
  className: PropTypes.string
};

export default PriceLine;
